import {createFeatureSelector, createSelector} from "@ngrx/store";
import {ResearchQueueFeatureKey} from "./research-queue.reducer";
import {ResearchQueue} from "../../models/ResearchQueue";

export const ResearchQueueSelector = createFeatureSelector<ResearchQueue[]>(ResearchQueueFeatureKey);
